import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import UserAccount from '../screens/UserAccount';
import Dashboard from '../screens/Dashboard';
// import DashboardContents from '../components/DashboardContents/DashboardContents';
import Commuters from '../components/Users/Commuters';
import EditUser from '../components/Users/EditCommuter';
import Payments from '../components/Payments/Payments';
import AwardedPoints from '../components/AwardedPoints/AwardedPoints';
import LoginPage from '../components/LoginPage/LoginPage';
import SignupForm from '../components/SignupForm/SignupForm';
import ForgotForm from '../components/ForgotForm/ForgotForm';
import ResetPassword from '../components/ForgotForm/ResetPassword';
import Profile from '../components/Profile/Profile';
import VerifyForm from '../components/ForgotForm/VerifyForm';
// import RedeemRewards from '../components/RedeemRewards/RedeemRewards';
// import RedeemPoints from '../components/RedeemPoints/RedeemPoints';
import Settings from '../components/Setting/Setting';
import Agencies from '../components/Agencies/Agencies';
import Stations from '../components/Stations/Stations';
import QRCodes from '../components/QRCodes/QRCodes';
import ViewQRCode from '../components/QRCodes/ViewQRCode';
import EditQRCode from '../components/QRCodes/EditQRCode';
// import AddAgencies from '../components/Agencies/AddAgencies';
import EditAgencies from '../components/Agencies/EditAgencies';
import Vendors from '../components/Vendors/Vendors';
import AddVendors from '../components/Vendors/AddVendors';
import EditVendors from '../components/Vendors/EditVendors';
import RoutesList from '../components/Routes/Routes';
// import AddRoutes from '../components/Routes/AddRoutes';
// import EditRoutes from '../components/Routes/EditRoutes';
import ForgetPassword from '../components/ForgetPassword/ForgetPassword';
import VerifyPassword from '../components/VerifyPassword/VerifyPassword';
import ChangePassword from '../components/ChnagePassword/ChangePassword';
import Home from '../components/Home/Home';
import RadeemPointsSettings from '../components/RedeemPoints/RadeemPointsSettings';
import RewardPoints from '../components/RewardPoints/RewardPoints';
import '../assets/css/styles.css';
import RedeemRewardPoints from '../components/RedeemRewards/RedeemRewards';
import UserDetail from '../components/Users/CommuterDetail';
import RouteDetail from '../components/Routes/RouteDetail';
import AwardedPointDetail from '../components/AwardedPoints/AwardedPointDetail';
import RewardPointDetails from '../components/RewardPoints/RewardPointDetails';
import RedeemRewardDetail from '../components/RedeemRewards/RedeemRewardDetail';
import EditRedeemRewardPoint from '../components/RedeemRewards/EditRedeemRewardPoint';
import AgencyDetails from '../components/Agencies/AgencyDetails';
import VendorDetail from '../components/Vendors/VendorDetail/VendorDetail';
import EditRewardPoints from '../components/RewardPoints/EditRewardPoints';
import AddRewardPoints from '../components/RewardPoints/AddRewardPoints';
import RewardPointSetting from '../components/RewardPoints/RewardPointSetting';
import StationDetail from '../components/Stations/StationDetail';
// import EditStation from '../components/Stations/EditStation';
// import AddStation from '../components/Stations/AddStation';
import Trips from '../components/Trips/Trips';
import TripsDetails from '../components/Trips/TripsDetials';
import { useAuth } from '../hooks/useAuth';
import BookingsConfigForm from '../components/TripBookings/BookingsConfigForm';
import BookingsList from '../components/Bookings/Bookings';
import BookingDetails from '../components/Bookings/BookingsDetail';
import PaymentSettings from '../components/PaymentSettings/PaymentSettings';
import Demographics from '../components/Demographics/Demographics';
import QuestionsAnswers from '../components/Demographics/QuestionsAnswers';
import AddDemograph from '../components/Demographics/AddDemograph';
import RewardSettings from '../components/Demographics/RewardSettings';
import Branches from '../components/Branches/Branches';
import Offers from '../components/Offers/Offers';
import AddEditBranch from '../components/Branches/AddEditBranch';
import AddEditOffer from '../components/Offers/AddEditOffer';
import OfferDetail from '../components/Offers/OfferDetail';
import BranchDetail from '../components/Branches/BranchDetail';
import RedemptionHistory from '../components/RedemptionHistory/RedemptionHistory';
import RedemptionHistoryDetail from '../components/RedemptionHistory/RedemptionHistoryDetail';
import MenuItems from '../components/MenuItems/MenuItems';
import AddEditMenuItem from '../components/MenuItems/AddEditMenuItem';
import MenuItemDetail from '../components/MenuItems/MenuItemDetail';

function ApplicationRoutes() {
    const { user } = useAuth();

    const ProtectedRoute = ({ children, allowedRoles }) => {
        if (!user) {
            return <Navigate to="/login" />;
        }

        if (allowedRoles && !allowedRoles.includes(user.role)) {
            return <Navigate to="/" />;
        }

        return children;
    };

    return (
        <>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<UserAccount />}>
                    <Route index element={<SignupForm />} />
                </Route>
                <Route path="/forgot" element={<UserAccount />}>
                    <Route index element={<ForgotForm />} />
                </Route>
                <Route path="/reset" element={<UserAccount />}>
                    <Route index element={<ResetPassword />} />
                </Route>
                <Route path="/verify" element={<UserAccount />}>
                    <Route index element={<VerifyForm />} />
                </Route>

                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Home />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/commuters" element={<Commuters />} />
                    <Route path="/commuters/commuter-details" element={<UserDetail />} />
                    <Route path="/commuters/edit-commuter" element={<EditUser />} />
                    <Route path="/demographics-questions" element={<QuestionsAnswers />} />
                    <Route path="/demographics/reward-tiers" element={<RewardSettings />} />
                    <Route path="/demographics/rewards" element={<RewardSettings />} />
                    <Route path="/frequently-used-locations" element={<Demographics />} />
                    <Route path="/frequently-used-locations/add-location" element={<AddDemograph />} />
                    <Route path="/agencies" element={<Agencies />} />
                    <Route path="/stops" element={<Stations />} />
                    <Route path="/qr-codes" element={<QRCodes />} />
                    <Route path="/qr-codes/view" element={<ViewQRCode />} />
                    <Route path="/qr-codes/edit" element={<EditQRCode />} />
                    {/* <Route path="/agencies/add-agency" element={<AddAgencies />} /> */}
                    <Route path="/agencies/agency-detail" element={<AgencyDetails />} />
                    <Route path="/agencies/edit-agency" element={<EditAgencies />} />
                    <Route path="/vendors" element={<Vendors />} />
                    <Route path="/vendors/edit-vendor" element={<EditVendors />} />
                    <Route path="/vendors/vendor-detail" element={<VendorDetail />} />
                    <Route path="/vendors/add-vendor" element={<AddVendors />} />
                    <Route path="/routes" element={<RoutesList />} />
                    {user?.role !== 'agency' && (
                        <>
                            <Route
                                path="/bookings"
                                element={
                                    <ProtectedRoute allowedRoles={['admin', 'vendor', 'commuter']}>
                                        <BookingsList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/bookings/booking-details/:id?"
                                element={
                                    <ProtectedRoute allowedRoles={['admin', 'vendor', 'commuter']}>
                                        <BookingDetails />
                                    </ProtectedRoute>
                                }
                            />
                        </>
                    )}
                    {/* <Route path="/routes/add-route" element={<AddRoutes />} /> */}
                    {/* <Route path="/routes/edit-route" element={<EditRoutes />} /> */}
                    <Route path="/routes/route-detail" element={<RouteDetail />} />
                    {/* Routes changed upon client feedback */}
                    <Route path="/rewards-accrual" element={<AwardedPoints />} />
                    <Route path="/rewards-accrual/awarded-points-details" element={<AwardedPointDetail />} />
                    {/* end Routes changed upon client feedback */}
                    <Route path="/reward-points" element={<RewardPoints />} /> {/**Should be setting only */}
                    <Route path="/reward-points/reward-point-details" element={<RewardPointDetails />} />
                    {/**Conflict */}
                    <Route path="/reward-points/edit-rewards-points" element={<EditRewardPoints />} />
                    <Route path="/reward-points/add-rewards-points" element={<AddRewardPoints />} />
                    <Route path="/reward-points-setting" element={<RewardPointSetting />} />
                    {/**Conflict */}
                    <Route path="/rewards-redemption-history" element={<RedeemRewardPoints />} />
                    <Route path="/redeemed-rewards/redeemed-reward-details" element={<RedeemRewardDetail />} />
                    <Route path="/edit-redeem-rewards" element={<EditRedeemRewardPoint />} />
                    {/* <Route path="/redeem-points" element={<RedeemPoints />} /> */}
                    <Route path="/redeem-points-settings" element={<RadeemPointsSettings />} />
                    <Route path="/stops/stop-detail" element={<StationDetail />} />
                    {/* <Route path="/stops/edit-stop" element={<EditStation />} /> */}
                    {/* <Route path="/stops/add-stop" element={<AddStation />} /> */}
                    {/* Trips */}
                    <Route path="/trips" element={<Trips />} />
                    <Route path="/trips/trip-details" element={<TripsDetails />} />
                    <Route path="/bookings/booking-details/:id?" element={<BookingDetails />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/fare-settings" element={<BookingsConfigForm />} />
                    <Route path="/payment-settings" element={<PaymentSettings />} />
                    <Route path="/branches" element={<Branches />} />
                    <Route path="/branches/add-branch" element={<AddEditBranch />} />
                    <Route path="/branches/edit-branch" element={<AddEditBranch />} />
                    <Route path="/branches/branch-details" element={<BranchDetail />} />
                    <Route path="/rewards" element={<Offers />} />
                    <Route path="/rewards/add-reward" element={<AddEditOffer />} />
                    <Route path="/rewards/edit-reward" element={<AddEditOffer />} />
                    <Route path="/rewards/reward-details" element={<OfferDetail />} />
                    <Route path="/redemptions" element={<RedemptionHistory />} />
                    <Route path="/redemptions/redemption-detail" element={<RedemptionHistoryDetail />} />
                    <Route path="/menu-items" element={<MenuItems />} />
                    <Route path="/menu-items/add-menu-item" element={<AddEditMenuItem />} />
                    <Route path="/menu-items/edit-menu-item" element={<AddEditMenuItem />} />
                    <Route path="/menu-items/menu-item-details" element={<MenuItemDetail />} />
                    {/* <Route path="/profile" el/agencies/edit-agencyement={<Profile />} />
                    {/*
                    <Route path="/Users/:user" element={<EditUser />} />
                    <Route path="/agencies" element={<Agencies />} />
                    <Route path="/agencies/add" element={<AddAgencies />} />
                    <Route path="/agencies/:member" element={<EditAgencies />} />

                    <Route path="/vendors" element={<Vendors />} />
                    <Route path="/vendors/add" element={<AddVendors />} />
                    <Route path="/vendors/:vendor" element={<EditVendors />} />

                    <Route path="/routes" element={<RoutesList />} />
                    <Route path="/routes/add" element={<AddRoutes />} />
                    <Route path="/routes/:route" element={<EditRoutes />} />
                     */}
                    <Route path="/vendors" element={<Payments />} />
                    {/* <Route path="/reports" element={<AwardedPoints />} /> */}
                    {/* <Route path="/redeem-rewards" element={<RedeemRewards />} />
                    <Route path="/redeem-points" element={<RedeemPoints />} /> */}
                    <Route path="/setting" element={<Settings />} />
                </Route>
                {/* Forget password */}

                <Route path="/forget-password" element={<ForgetPassword />} />
                <Route path="/verify-password" element={<VerifyPassword />} />
                <Route path="/change-password" element={<ChangePassword />} />
                {/* Catch-all route for unmatched paths */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </>
    );
}

export default ApplicationRoutes;
